// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/ResourceListPage/i18n.json';

import { ChangeEvent } from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import MainDocument from 'presentations/views/components/MainDocument';
import ResourceListPage from 'presentations/views/components/pages/ResourceListPage';
import { apiPath, resourceListPath, webPath } from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { ResourceListItem } from 'presentations/api/schema/resources';

interface ServerProps {
  resources: ResourceListItem[];
  currentPage: number;
  numberOfPages: number;
  linkCanonical: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  locale,
  defaultLocale,
}: any) => {
  const page = req.query.page || null;

  const result = await get(apiPath(`/v1/resources`, { page }));
  if (!result.isSuccess) {
    return { props: { statusCode: 404 } };
  }
  if (!result.data) {
    return { props: { statusCode: 404 } };
  }
  if (locale !== defaultLocale) {
    return { props: { statusCode: 404 } };
  }
  const resources: ResourceListItem[] = result.data;
  const currentPage = result.currentPage ? Number(result.currentPage) : 1;
  const props: ServerProps = {
    resources,
    currentPage,
    numberOfPages: result.numberOfPages ? Number(result.numberOfPages) : 0,
    linkCanonical: webPath(
      resourceListPath({
        page: currentPage > 1 ? currentPage : undefined,
      }),
      locale,
    ),
  };
  return { props };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const router = useRouter();

  const onChangePage = (e: ChangeEvent, value: number) => {
    const options = { page: value };
    router.push(resourceListPath(options));
    window.scrollTo(0, 0);
  };

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      locales={['ja']}
      isExcludeSiteName
      isUseAdsense
      linkCanonical={props.linkCanonical}
    >
      <ResourceListPage
        title={t('title')}
        isTop
        tag={null}
        category={null}
        resourceListProps={{
          items: props.resources,
          paginationProps: {
            currentPage: props.currentPage,
            numberOfPages: props.numberOfPages,
            onChange: onChangePage,
          },
        }}
      />
    </MainDocument>
  );
}
